import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiAlert = _resolveComponent("UiAlert")!

  return (_ctx.title)
    ? (_openBlock(), _createBlock(_component_UiAlert, {
        key: 0,
        type: "error",
        class: _normalizeClass({ dense: !_ctx.$slots.description }),
        message: _ctx.title,
        closable: ""
      }, {
        description: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.text), 1)
          ], true)
        ]),
        _: 3
      }, 8, ["class", "message"]))
    : _createCommentVNode("", true)
}